import _styled from '@emotion/styled/base';
import { useTheme } from '@emotion/react';
import { useRef, useEffect } from 'react';
import { Spacing } from '../../primitives/spacing.js';
import { Text } from '../../Text/index.js';
import { SectionMessage } from '../index.js';
import { jsx } from '@emotion/react/jsx-runtime';

const STATUS_TYPE = 'alert';
const BulletedLI = _styled("li", {
  target: "e187qeog1"
})("list-style:disc;margin-left:", Spacing.scale[2], ";");
const MIN_ERRORS_FOR_SUMMARY = 3;
const SectionMessageFormErrorsWrapper = _styled("div", {
  target: "e187qeog0"
})();
function SectionMessageFormErrors({
  formErrorLinks
}) {
  const {
    translate
  } = useTheme();
  const HEADING_TEXT = translate('SectionMessage.errorsFound');
  const firstLinkRef = useRef(null);
  const initialErrorCount = useRef(formErrorLinks.length);
  const hasMinimumErrorCount = initialErrorCount.current >= MIN_ERRORS_FOR_SUMMARY;
  useEffect(() => {
    if (!hasMinimumErrorCount) return;
    firstLinkRef === null || firstLinkRef === void 0 ? void 0 : firstLinkRef.current.focus();
  }, [hasMinimumErrorCount]);
  if (!hasMinimumErrorCount) return null;
  return jsx(SectionMessageFormErrorsWrapper, {
    children: jsx(SectionMessage, {
      heading: HEADING_TEXT,
      statusType: STATUS_TYPE,
      children: jsx("ul", {
        children: formErrorLinks.map((item, index) => {
          return jsx(BulletedLI, {
            children: jsx(Text.Link, {
              fontSize: "14px",
              href: item.href,
              ref: index === 0 ? firstLinkRef : null,
              children: item.text
            })
          }, item.href);
        })
      })
    })
  });
}

export { SectionMessageFormErrors, SectionMessageFormErrorsWrapper };
